import React, {Component} from 'react'

import styled from 'styled-components'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {faInfoCircle} from '@fortawesome/fontawesome-free-solid'
import ReactModal from 'react-modal';
import CLOSE_ICON from './close.png';

import {apiFetchOptions} from "../../apis/calculator";

class VehicleSpecs extends Component {
    state=  {
        pop: false,
        optionsMsg: []
    }

    info() {
        const overlay = {
            position: 'fixed',
            maxHeight: 100 + '%',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 21,
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
        },
            modal = {
                wrapper: {
                    width: 80 + '%',
                    maxWidth: 650 + 'px',
                    backgroundColor: 'white',
                    margin: '5% auto',
                    padding: 30 + 'px'
                },
                title: {
                    textTransform: 'uppercase',
                    color: 'black',
                    fontSize: 22.4 + 'px'
                },
                content: {
                    color: 'grey',
                    whiteSpace: 'pre-wrap',
                    textAlign: 'left',
                    overflowY: 'scroll',
                    height: '395px'
                },
                closeIcon: {
                    width: 15 + 'px',
                    height: 15 + 'px',
                    float: 'right',
                    cursor: 'pointer',
                    display: 'block',
                    marginTop: -10 + 'px'
                },
                icon: {
                    width: 15 + 'px',
                    height: 15 + 'px'
                },
                remark: {
                    textTransform: 'uppercase',
                    textAlign: 'left'
                },
                even: {
                    color: "#808080"
                },
                odd: {
                    color: "#000"
                }
            }
        return  <div> 
                    Options <i className={'infoIcon'} onClick={()=>this.togglepop()}><FontAwesomeIcon icon={faInfoCircle} alt="" /></i>
                    <ReactModal isOpen={this.state.pop} className="text-center" style={{overlay: overlay}}>
                        <div style={modal.wrapper}>
                            <a style={modal.closeIcon} className="text-right" onClick={e=>this.togglepop()} href="javascript:void(0)">
                                <img src={CLOSE_ICON} style={modal.icon} alt=""/>
                            </a>
                            <p style={modal.title}>OPTION LIST</p>
                            <p style={modal.content}>
                                {
                                    this.state.optionsMsg.map(function(item, i){
                                        if (i % 2 == 0) {
                                            return <div style={modal.even} key={i}>{item}</div>
                                        } else {
                                            return <div style={modal.odd} key={i}>{item}</div>
                                        }
                                      })
                                }
                            </p>
                            <br />
                            <p style={modal.remark}>
                                Remarks: <br />
                                Options detail will be provided with the final confirmation document
                            </p>
                        </div>
                    </ReactModal>
                </div>
    }
    togglepop() {
        this.state.pop ? this.setState({pop: false}) : this.setState({pop: true});
    }

    componentDidMount() {
        console.log()
        let token = '';
            // apiFetchOptions(token).then((r)=>{

            //     const str = r.optionBody.split('__LINEBREAK')

            //     this.setState({ optionsMsg : str});
            //   }).catch((e)=>{
            //       console.log(e)
            //   })
    }


    render() {
        const {className} = this.props;
        const {fields} = this.props;
        return <div className={className}>
            {
                fields.map((i, index) => {
                    // if (!i.value) {return}
                    return <div key={index}
                                className={`field-row field-row_size_1x d-block`}>
                        <div className={`field-label h-100 w-100`}>
                            <div className="d-block w-100 flex-row justify-content-end align-items-center h-100">
                                <div className='label'>
                                    {
                                        i.label === "OPTIONS" ? this.info() : i.label
                                    }
                                </div>
                            </div>
                        </div>

                        <div className={`field-control h-100 w-100`}>
                            <div className="w-100 h-100 d-block flex-row align-items-center dont-break-out">
                                {i.value}
                            </div>
                        </div>
                    </div>
                })
            }
        </div>
    }
}

export default styled(VehicleSpecs)`

& {
  max-width: 450px;
  margin: 23px auto;
  margin-right: 2.5%;
  @media (max-width: 1000px){
      margin: 0 auto 20px;
      margin-right: 0;
  }
  @media (min-width: 1000px) {
      margin-left: 0;
      margin-right: 0;
      width: 100%;
      max-width: 100%;
  }
}
.field-row_size_1x {
    height: auto!important;
    padding: 15px 0px;
}
.field-row {
  &:nth-child(odd) {
      background-color: ${props => props.theme.calculatorBodyColor};
  }
  &:nth-child(even) {
      background-color: white;
  }
//   @media (min-width: 1000px) {
//     width: 45%;
//     margin-right: 20px;
//     display: inline-block !important;

//     &:nth-child(odd), &:nth-child(even) {    
//         background-color: ${props => props.theme.calculatorBodyColor};
//     }
    

//     &:nth-child(3), &:nth-child(4) {
//         background-color: white;
//     }
//   }
  &_size {
    &_1x {
      height: 60px;
    }
    &_2x {
      height: 120px;
    }
  }
}

.field-row {
  display: flex;
  
  .field-label {
      width: 32%;
      text-align: center;
      
      color: rgba(25,25,25,0.5);
      font-weight: 100;
      @media (max-width: 360px){
         width: 35%; 
      }
      .label{
          text-align: left;
          font-size: 0.75rem;
          margin-top: 4px;
          margin-left: 15px;
        @media (max-width: 360px){
            font-size: 0.7rem;
         }
      }
  }
  
  .field-control {
      width: 68%;
      flex: 1;
      color: rgba(0, 0, 0, 0.7);
      font-size: 18.75px;
      
      @media (max-width: 360px) {
        width: 65%;
        padding: 0 12px 0 17.5px;  
        font-size: 18.7px;
      }
      
      @media (min-width: 361px) {
        padding: 0 12px 0 15px;
      }
      
  }
    .dont-break-out {
    overflow-wrap: break-word;
    word-wrap: break-word;

    -ms-word-break: break-all;
    word-break: break-all;
    word-break: break-word;

    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
    }
}

.infoIcon {
    cursor: pointer;
}
`


// WEBPACK FOOTER //
// ./src/components/configurator/VehicleSpecs.js